export enum NamingTypeEnum {
  OnlyName = 'OnlyName',
  NameWithNumber = 'NameWithNumber',
  OnlyNumber = 'OnlyNumber',
}
